module.exports = __webpack_public_path__ + "img/Testimoni_David-TRON.c46d43fc.png";